import React, { lazy } from 'react';
import { useReveal } from '../lib/useReveal';
const PAGES = [{
  image: 'https://cdn.magicpatterns.com/uploads/reSzYdrpLgdU8jwGqYk3od/Screenshot_2026-02-13_110339.png',
  label: 'El origen: Mikao Usui'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/qXzRW6ckAFLzUSEcF1V7jL/Screenshot_2026-02-13_110621.png',
  label: 'Chakra Sacro — Ubicación y Características'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/i4C1LcJbsrrc2V29UiUdkp/Screenshot_2026-02-13_110736.png',
  label: 'Chakra Corona — Conciencia · Unidad'
}];
export function PagePreviewSection() {
  const [ref1, vis1] = useReveal();
  const [ref2, vis2] = useReveal();
  return <section className="bg-[#1a1a2e] py-14 md:py-20 px-4 overflow-hidden border-t border-white/5" data-id="element-258">
      <div className="container mx-auto max-w-6xl" data-id="element-259">
        <div ref={ref1} className={`reveal text-center mb-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-260">
          <span className="text-[#f0c040] text-sm font-bold tracking-[0.2em] uppercase mb-4 block" data-id="element-261">
            📖 Vista previa
          </span>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-4 leading-tight" data-id="element-262">
            Revisá algunas páginas
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto" data-id="element-263">
            Contenido real del curso. Diseñado para que aprendas con claridad y
            profundidad.
          </p>
        </div>

        <div ref={ref2} className={`reveal grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 ${vis2 ? 'is-visible' : ''}`} data-id="element-264">
          {PAGES.map((page, idx) => <div key={idx} className="group" style={{
          transitionDelay: `${idx * 150}ms`
        }} data-id="element-265">
              <div className="relative bg-[#252538] p-2 md:p-3 rounded-2xl shadow-[0_8px_30px_-8px_rgba(0,0,0,0.4)] border border-white/10 transition-all duration-500 hover:scale-[1.02] hover:shadow-[0_16px_50px_-10px_rgba(212,160,23,0.15)] hover:border-[#d4a017]/30" data-id="element-266">
                <div className="overflow-hidden rounded-xl bg-white" data-id="element-267">
                  <img src={page.image} alt={page.label} className="w-full h-auto object-cover" loading="lazy" data-id="element-268" />
                </div>
              </div>
              <p className="text-center mt-4 text-sm font-bold text-gray-400 uppercase tracking-wider" data-id="element-269">
                {page.label}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}